import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  GETTING_FREE_TRIAL_REPORT,
  UPDATE_FREE_TRIAL_REPORT_INFO,
  DOWNLOADING_FREE_TRIAL_REPORT,
  DOWNLOAD_PDF_SUCCESSFUL,
  CLOSE_DOWNLOAD_SUCCESS_TOASTER,
} from './actionTypes';

import { API_ENDPOINT } from '../constants';

export const updateFreeTrialReportInfo = (dispatch, freeTrialReportInfo) => {
  dispatch({ type: UPDATE_FREE_TRIAL_REPORT_INFO, payload: freeTrialReportInfo });
};

export const getFreeTrialDownloadReport = createAsyncThunk(
  GETTING_FREE_TRIAL_REPORT,
  async ({ freeTrialId }, methods) => {
    const { dispatch } = methods;
    let response;

    try {
      dispatch({ type: GETTING_FREE_TRIAL_REPORT });
      const res = await axios.get(`${API_ENDPOINT}/free_trial_reports/${freeTrialId}/`);
      response = res?.data || {};
    } catch (error) {
      console.error(error);
    }

    dispatch((dispatch) => updateFreeTrialReportInfo(dispatch, response));
  },
);

export const downloadReportPDF = createAsyncThunk(
  DOWNLOADING_FREE_TRIAL_REPORT,
  async ({ financeLenderId, templateData, user }, methods) => {
    const { dispatch } = methods;
    let response;

    try {
      dispatch({ type: DOWNLOADING_FREE_TRIAL_REPORT });

      if (process.env.NODE_ENV === 'development') {
        const res = await axios.post(
          `${API_ENDPOINT}/finance_lenders/${financeLenderId}/download_report`,
          {
            templateData,
            user,
          },
          { responseType: 'blob' },
        );
        response = res?.data || {};

        const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${templateData.lenderName}-free-trial-report.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        const res = await axios.post(
          `${API_ENDPOINT}/finance_lenders/${financeLenderId}/download_report`,
          {
            templateData,
            user,
          },
        );

        response = res?.data || {};

        const a = document.createElement('a');
        a.href = response.url;
        a.target = '_blank';
        a.click();
      }

      dispatch({ type: DOWNLOAD_PDF_SUCCESSFUL });
    } catch (error) {
      console.error(error);
      dispatch({ type: 'DOWNLOAD PDF FAILED' });
    }
  },
);

export const closeDownloadSuccessPdfToaster = (dispatch) => {
  dispatch({ type: CLOSE_DOWNLOAD_SUCCESS_TOASTER });
};
